import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ApplicantsRefreshContextType {
  refresh: boolean;
  triggerRefresh: () => void;
}

const ApplicantsRefreshContext = createContext<
  ApplicantsRefreshContextType | undefined
>(undefined);

export const ApplicantsRefreshProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [refresh, setRefresh] = useState(false);

  const triggerRefresh = () => {
    // Toggle the refresh flag
    setRefresh((prev) => !prev);
  };

  return (
    <ApplicantsRefreshContext.Provider value={{ refresh, triggerRefresh }}>
      {children}
    </ApplicantsRefreshContext.Provider>
  );
};

export const useApplicantsRefresh = (): ApplicantsRefreshContextType => {
  const context = useContext(ApplicantsRefreshContext);
  if (!context) {
    throw new Error(
      'useApplicantsRefresh must be used within an ApplicantsRefreshProvider'
    );
  }
  return context;
};
